import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

type CheckBoxProps = {
  onSubmit: (value: boolean) => Promise<any>;
  checked?: boolean;
};

export const CheckBox = (props: CheckBoxProps) => {
  const [value, setValue] = useState<boolean>(props.checked || false);
  const [loading, setLoading] = useState<boolean>(false);
  const { onSubmit } = props;

  useEffect(() => {
    setValue(props.checked || false);
  }, [props.checked]);

  const submit = async (checked: boolean) => {
    setLoading(true);
    try {
      await onSubmit(checked);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <CircularProgress sx={{ mr: '2px', color: '#007ca3', verticalAlign: 'middle' }} size={18} color="inherit" />}
      {!loading && <Checkbox onChange={e => submit(e.target.checked)} checked={value} color="primary" inputProps={{ 'aria-label': 'secondary checkbox' }} />}
    </div>
  );
};
